import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/* eslint-disable no-console */
/* eslint-disable no-await-in-loop */

export function constantBackOff() {
  var interval = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;
  return function (attemptCount) {
    return attemptCount * interval;
  };
}
export function exponentialBackOff() {
  var interval = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var base = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
  return function (attemptCount) {
    return min + Math.pow(base, attemptCount) * interval;
  };
}
function sleep(_x) {
  return _sleep.apply(this, arguments);
}
function _sleep() {
  _sleep = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(milliseconds) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return new Promise(function (r) {
            return setTimeout(r, milliseconds);
          });
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _sleep.apply(this, arguments);
}
export default function retry(_x2) {
  return _retry.apply(this, arguments);
}
function _retry() {
  _retry = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(func) {
    var attempts,
      backOffFunc,
      attempt,
      _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          attempts = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : 3;
          backOffFunc = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : constantBackOff();
          attempt = 1;
        case 3:
          if (!(attempt <= attempts)) {
            _context2.next = 20;
            break;
          }
          _context2.prev = 4;
          _context2.next = 7;
          return func();
        case 7:
          return _context2.abrupt("return", _context2.sent);
        case 10:
          _context2.prev = 10;
          _context2.t0 = _context2["catch"](4);
          if (!(attempt - 1 === attempts)) {
            _context2.next = 14;
            break;
          }
          throw _context2.t0;
        case 14:
          _context2.next = 16;
          return sleep(backOffFunc(attempt));
        case 16:
          console.warn("Retrying func ".concat(func.name, " with error ").concat(_context2.t0));
        case 17:
          attempt += 1;
          _context2.next = 3;
          break;
        case 20:
          return _context2.abrupt("return", func());
        case 21:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[4, 10]]);
  }));
  return _retry.apply(this, arguments);
}